import { forwardRef } from "react";
import ThreeImageGrid from "@/Components/ThreeImageGrid.tsx";
import default_profile_image from "../assets/default_image.png";
import { TYPE_ICONS } from "@/Components/Home/CampaignCard.tsx";
import { useThemeAsset } from "@/Hooks/useThemeAsset.ts";
import useCampaignDeadline, {
  useCampaignDeadlineProps,
} from "@/Hooks/useCampaignDeadline.ts";
import { Link } from "react-router-dom";

const S3_URL = import.meta.env.VITE_S3_URL;

export type FamtourCardProps = {
  item: {
    id: string;
    title: string;
    app_end_date: useCampaignDeadlineProps["registrationEnd"];
    images: string[];
    planner_link: string;
    planner_nickname: string;
    planner_thumbnail: string;
    type: string;
    expired_in_days: useCampaignDeadlineProps["expirationInDays"];
  };
  isLastItem?: boolean; // ✅ Tambahan baru
};

const FamtourCard = forwardRef<HTMLAnchorElement, FamtourCardProps>(
  ({ item, isLastItem = false }, ref) => {
    const { typeIcons } = useThemeAsset();
    const { daysLeft, isClosed } = useCampaignDeadline({
      registrationEnd: item.app_end_date,
      expirationInDays: item.expired_in_days,
    });

    return (
      <Link to={`/detailFamtour/${item.id}`} ref={ref}>
        <ThreeImageGrid className="mb-1.5" images={item.images} />
        <div
          className={`flex w-full pb-2 ${isLastItem ? "" : ""}`}
        >
          {/* Left */}
          <div className="flex flex-col w-full">
            <div className="w-full flex justify-between space-x-1">
              <div className="flex space-x-1 items-center text-[8px]">
                <div>
                  <img
                    src={typeIcons.blog.active || TYPE_ICONS.blog.active}
                    alt="blog"
                    className="w-[16px] h-[16px] rounded-full"
                  />
                </div>
                <div className="text-[8px]">
                  {isClosed
                    ? "발표마감"
                    : daysLeft > 0
                    ? `${daysLeft}일 남음`
                    : daysLeft === 0
                    ? "마감임박"
                    : "발표마감"}
                </div>
              </div>

              {/* Right */}
              {item.planner_link ||
              item.planner_nickname ||
              item.planner_thumbnail ? (
                <div className="flex items-center space-x-2">
                  <img
                    src={
                      item.planner_thumbnail
                        ? `${S3_URL}${item.planner_thumbnail}`
                        : default_profile_image
                    }
                    alt="Avatar"
                    className="w-[17px] h-[17px] rounded-full"
                  />
                  <span className="text-[10px] text-[#666666]">
                    {item.planner_nickname}
                  </span>
                </div>
              ) : null}
            </div>

            <div className="text-[12px] font-semibold mt-0.5 flex-1 line-clamp-1">
              {item.title}
            </div>
          </div>
        </div>
      </Link>
    );
  }
);

FamtourCard.displayName = "FamtourCard";

export default FamtourCard;
